import { v4 as uuidv4 } from "uuid";

/**
 * Helper method to generate an unique UUID
 * @returns A unique UUID
 */
export const generateUUID = (): string => {
  return uuidv4();
};

export const maskUaeMobile = (mobile: string | null | undefined): string => {
  if (!mobile) return ""; // Return empty string for null/undefined values

  // Remove non-numeric characters (keep only digits)
  const cleaned = mobile.replace(/\D/g, "");

  // Handle UAE mobile numbers (10-digit local format or 12-digit international format)
  if (cleaned.length === 10) {
    return cleaned.replace(/^(\d{3})(\d{3})(\d{4})$/, "$1-***-$3");
  } else if (cleaned.length === 12 && cleaned.startsWith("971")) {
    return cleaned.replace(/^(971\d{1})(\d{3})(\d{4})$/, "$1-***-$3");
  }

  return mobile; // Return as is if it doesn't match UAE format
};

export const maskEmail = (email: string): string => {
  console.log(email);
  if (!email || !email.includes("@")) return email; // Return as is if invalid

  const [localPart, domain] = email.split("@");

  if (localPart.length <= 2) {
    return `${localPart[0]}****@${domain}`; // Handle very short usernames
  }

  return `${localPart[0]}*****${localPart[localPart.length - 1]}@${domain}`;
};
